import { makeStyles, tokens } from "@fluentui/react-components";
import { iconFilledClassName, iconRegularClassName } from "@fluentui/react-icons";

export const backgroundColorSeaGreen = "hsl(146, 50%, 36%)";
export const backgroundColorSeaGreenHover = "hsl(146, 50%, 32%)";
export const backgroundColorSeaGreenActive = "hsl(146, 50%, 28%)";

export const useFormStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    gap: "0.5rem",
  },

  control: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  },

  controlFooter: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: "5px",
  },
});

export const usePageStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignContent: "center",
    paddingLeft: "1.5rem",
    paddingRight: "1.5rem",
    paddingTop: "4rem",
    paddingBottom: "4rem",
    minHeight: "calc(100vh - 8rem)",
    maxHeight: "100%",
  },
});

export const useBrandBarStyles = makeStyles({
  container: {
    position: "fixed",
    left: 0,
    right: 0,
    zIndex: 1000,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: "3.75rem",
    padding: "0 1.5rem",
    boxShadow: tokens.shadow64,
  },
  light: {
    backgroundColor: backgroundColorSeaGreen,
    color: tokens.colorNeutralBackground2,
  },
  dark: {
    backgroundColor: tokens.colorNeutralBackground5,
    color: tokens.colorNeutralForeground1,
  },
});

export const useIconButtonStyles = makeStyles({
  light: {
    color: tokens.colorNeutralBackground2,
    "&:hover": {
      [`& .${iconFilledClassName}`]: {
        display: "block",
        color: tokens.colorNeutralBackground2,
      },
      [`& .${iconRegularClassName}`]: {
        display: "none",
      },
      color: tokens.colorNeutralBackground2,
    },
  },
  dark: {
    color: tokens.colorNeutralForeground1,
    "&:hover": {
      [`& .${iconFilledClassName}`]: {
        display: "block",
        color: `${backgroundColorSeaGreen}`,
      },
      [`& .${iconRegularClassName}`]: {
        display: "none",
      },
      color: tokens.colorNeutralForeground1,
    },
  },
});
